
import { lazy } from "react";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Navigate } from "react-router-dom";

const CommonPointCreate = lazy(() => import("../components/commonPointCreate"));
const CommonPointList = lazy(() => import("../components/commonPointList"));

const commonPointRoute = {
  icon: LocationOnIcon,
  name: "Location Management",
  link: "/location-management",
  path: "location-management",
  index: 15,
  element: "",
  superAdminView: false,
  children: [
    {
      path: "common-Point",
      element: <CommonPointList />,
      permission: "Common Point-Read",
      name: "Common Point",
      index: 2,
      link: "location-management/common-Point",
      icon: ZoomInMapIcon,
    },
    {
      path: "common-Point/create",
      element: <CommonPointCreate />,
    },
    {
      path: "common-Point/:id",
      element: <CommonPointCreate />,
    },
    {
      path: "",
      element: <Navigate to="location" replace />,
    },
  ],
};
export default commonPointRoute;
